import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import client from '../../api/client';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Spinner from '../../components/ui/Spinner';
import { horaLegible } from '../../utils/fechas';
import { TituloSeccion, TablaEnvoltura, Tabla, SinDatos } from './comunes';

const Tarjetas = styled.div`
  display: grid;
  gap: ${({ theme }) => theme.space.md};
  grid-template-columns: 1fr;
  margin-bottom: ${({ theme }) => theme.space.xl};

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    grid-template-columns: repeat(3, 1fr);
  }
`;

const Indicador = styled(Card)`
  h2 {
    font-family: ${({ theme }) => theme.fonts.heading};
    font-size: 2.2rem;
    color: ${({ theme }) => theme.colors.sageDeep};
  }

  p {
    font-size: 0.85rem;
    color: ${({ theme }) => theme.colors.textMuted};
  }
`;

const Enlace = styled(Link)`
  color: ${({ theme }) => theme.colors.sageDeep};
  font-weight: 600;
  text-decoration: underline;
  font-size: 0.9rem;
`;

function Dashboard() {
  const [datos, setDatos] = useState(null);

  useEffect(() => {
    client
      .get('/admin/reportes/dashboard')
      .then(({ data }) => setDatos(data))
      .catch(() => setDatos({ clasesHoy: [], reservasNuevasHoy: 0, ocupacionHoy: 0 }));
  }, []);

  if (!datos) return <Spinner />;

  return (
    <>
      <TituloSeccion>Resumen de hoy</TituloSeccion>
      <Tarjetas>
        <Indicador>
          <h2>{datos.clasesHoy.length}</h2>
          <p>Clases programadas hoy</p>
        </Indicador>
        <Indicador>
          <h2>{datos.ocupacionHoy}%</h2>
          <p>Ocupación promedio de hoy</p>
        </Indicador>
        <Indicador>
          <h2>{datos.reservasNuevasHoy}</h2>
          <p>Reservas nuevas hoy</p>
        </Indicador>
      </Tarjetas>

      <TituloSeccion as="h2" style={{ fontSize: '1.25rem' }}>
        Clases de hoy
      </TituloSeccion>
      <TablaEnvoltura>
        {datos.clasesHoy.length === 0 ? (
          <SinDatos>
            No hay clases programadas hoy. <Enlace to="/admin/clases">Programar clases</Enlace>
          </SinDatos>
        ) : (
          <Tabla>
            <thead>
              <tr>
                <th>Hora</th>
                <th>Clase</th>
                <th>Instructor</th>
                <th>Ocupación</th>
              </tr>
            </thead>
            <tbody>
              {datos.clasesHoy.map((c) => (
                <tr key={c.id}>
                  <td>{horaLegible(c.hora_inicio)}</td>
                  <td>{c.tipo_clase}</td>
                  <td>{c.instructor}</td>
                  <td>
                    <Badge $tono={c.cupo_disponible === 0 ? 'peligro' : 'exito'}>
                      {c.reservados}/{c.cupo_maximo}
                    </Badge>
                  </td>
                </tr>
              ))}
            </tbody>
          </Tabla>
        )}
      </TablaEnvoltura>
    </>
  );
}

export default Dashboard;
